import { render, staticRenderFns } from "./boardColumn.vue?vue&type=template&id=f8a0b090&scoped=true&"
import script from "./boardColumn.vue?vue&type=script&lang=js&"
export * from "./boardColumn.vue?vue&type=script&lang=js&"
import style0 from "./boardColumn.vue?vue&type=style&index=0&id=f8a0b090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a0b090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a0b090')) {
      api.createRecord('f8a0b090', component.options)
    } else {
      api.reload('f8a0b090', component.options)
    }
    module.hot.accept("./boardColumn.vue?vue&type=template&id=f8a0b090&scoped=true&", function () {
      api.rerender('f8a0b090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/internal-task/boardColumn.vue"
export default component.exports